export default "__VITE_ASSET__DnSgt7Mb__"